'use client';
import Bag from '@/app/_components/ui/icons/Bag.svg';
import Trash from '@/app/_components/ui/icons/Trash.svg';
import AddComments from '@/app/_components/ui/icons/AddComments.svg';
import Price from '../share/Price';
import Link from 'next/link';
import Img from '../share/Img';

export default function ProfileCard({ product, type, removeProduct }) {
  const addToCartHandler = () => {};

  return (
    <>
      {product ? (
        <div className="product-item  col-span-1 my-3 px-3 min-h-[480px]">
          <div className="bg-white  relative border p-3 border-light-gray-300 h-full rounded-md">
            <Link href={`/product/${product.slug}`}>
              <div className="flex w-full flex-col px-4 py-2">
                <div className="product-image relative pb-6 ">
                  <Img image={product.media.thumb} width={186} height={170} />
                  <div className="absolute top-4max-w-50px top-0 left-3.5">
                    <Img
                      images={product?.brand?.thumb}
                      width={50}
                      height={20}
                      noImage={false}
                    />
                  </div>
                </div>
                <div className="product-info flex-1">
                  <div>
                    <h2 className="mt-2.5 pb-2 text-sm  ">
                      {product.title}
                      <br />
                      <br />
                    </h2>
                  </div>
                  {type != 'comments' && (
                    <div className="os-product-price   pt-2 pb-5 ">
                      <Price price={product.prices[0]} />
                    </div>
                  )}
                </div>
              </div>
            </Link>

            {type != 'comments' ? (
              <div className="flex items-center absolute bottom-4 px-4 left-0 right-0 w-full">
                <div className="w-full flex">
                  {product.prices.length > 0 && !product.offline ? (
                    <button
                      className="py-2 px-3.5 flex items-center justify-center border border-color-primary w-full rounded-md"
                      onClick={addToCartHandler}
                    >
                      <Bag stroke="#2A75BB" />
                      <span className="text-color-primary text-sm pr-2">
                        افزودن به سبد خرید
                      </span>
                    </button>
                  ) : (
                    <Link
                      target="_blank"
                      className="py-2 px-3.5 flex items-center text-color-primary text-sm  justify-center border border-color-primary w-full rounded-md"
                      href={`/product/${product.slug}`}
                    >
                      مشاهده محصول
                    </Link>
                  )}
                  {type == 'lists' && (
                    <button
                      className="border border-gray text-gray-300 flex items-center p-2 rounded-md mr-2"
                      onClick={() => removeProduct(product.id)}
                    >
                      <Trash fill="#777" />
                      <span>حذف</span>
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className=" absolute bottom-4 px-4 left-0 right-0">
                <Link
                  target="_blank"
                  className="w-full border border-color-primary text-cetner text-color-primary py-2 rounded-md text-sm flex w-full justify-center "
                  href={`/product/${product.slug}`}
                >
                  <AddComments />
                  <span className="pr-2 text-color-primary">ثبت دیدگاه</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}
